import {COLOR_OFF, DIMENSIONS, LINN200} from "../model";
import {midi} from "./MidiStore";
import {CC} from "../utils/midi";

/*
    The LinnStore manage a array of Cell for all the available button in the LinnStrument.

    The first column hosts the Control Buttons.
    The next columns hosts the "Note".

    Coordinates:

    Internal:

    - Columns are 0..N (N=16|25)
    - Rows are 0..7

    - Column 0 is the left-most column, the column hosting the Control Buttons.
    - Column 1 is the first "Note" column.
    - Row 0 is the bottom row.
    - Row 7 is the top row.

    External:

    - The Cells available to the Store user are only the Note cells. The control switches (column 0) will be made available through ad-hoc methods.
    - the Cells are number as documented in the Linn user-mode documentation:
        - Rows = 1..8 (addressed with MIDI channels 1..8)
        - Columns = 1..25 (addresses with MIDI notes 1..25)

    In the code:

    - when col|row is used, this is for the absolute cells coordinates. col=0..25, row=0..7
    - when x|y is used, this is for the note coordinates. y=1..25, y=1..8

*/

// We keep track on the cell in order to avoid sending useless MIDI messages
interface LinnCell {    // All cells, including the control switches column 0
    col: number;
    row: number;
    color: number;
}

type LinnCells = Array<Array<LinnCell>>

class LinnStore {

    // cols = LINN_COLS;
    // rows = LINN_ROWS;
    cells: LinnCells;

    // notesCols = COLS - 1;   // because the first column is the control switches column
    // notesRows = ROWS;

    //TODO: grid offsets
    xOffset = 1;    // because the first note column is 1 not 0
    yOffset = 0;

    constructor(columns: number, rows: number) {
        // console.log("LinnStore constructor");

        this.cells = new Array<Array<LinnCell>>();

        for (let c = 0; c <= columns; c++) {   // column 0 is the control buttons. For the Linn-128 we therefore have 1+16 columns, for the Linn-200, we have 1+25 columns.
            const col: LinnCell[] = new Array<LinnCell>();
            for (let r = 0; r < rows; r++){
                col.push({
                    col: c,
                    row: r,
                    // on: false,
                    // vel: 0,             // TODO: include for control switches (column 0)?
                    color: COLOR_OFF       // current color if ON. Needed if we want to change the color of an ON cell; -1 means OFF
                    // x: 0, y: 0, z: 0    // TODO: include for control switches (column 0)?
                });
            }
            this.cells.push(col);
        }
    }

    enableUserMode() {
        midi.sendNRPN(1, 117, 1, 1);
        // this.midi.sendCC(64,1,0);
    }

    disableUserMode() {
        midi.sendNRPN(1, 117, 0, 1);
        // midi.sendCC(64,1,0);
    }

    // /**
    //  * To enable X data, send MIDI CC message 10 with value 1 to Channels 1 to 8, corresponding to the rows.
    //  * Sending value 0 instead will disable X data for a row. The same applies to Y and Z data, using MIDI CC messages 11 and 12
    //  * respectively.
    //  */
    // enableXAxisData() {
    //     for (let ch = 0; ch < 8; ch++) {
    //         midi.sendCC(10, 1, ch)
    //     }
    // }
    //
    // enableYAxisData() {
    //     for (let ch = 0; ch < 8; ch++) {
    //         midi.sendCC(11, 1, ch)
    //     }
    // }
    //
    // enableZAxisData() {
    //     for (let ch = 0; ch < 8; ch++) {
    //         // @ts-ignore
    //         midi.sendCC(12, 1, ch)
    //     }
    // }


    /**
     *
     * @param col   1..25
     * @param row   1..8
     * @param color
     * @param force if true will send the MIDI ON message even if the cell is already marked as ON
     */
    turnOnCell(col: number, row: number, color: number, force=false) {

        // console.log("this.turnOnCell", col, row, color);

        // CC Number   Used for
        // -------------------------------------------------------------------------------------------------------------
        // 20          Column coordinate for cell color change with CC 22 (starts from 0)
        // 21          Row coordinate for cell color change with CC 22 (starts from 0)
        // 22          Change the color of the cell with the provided column and row coordinates

        //FIXME: check parameters range

        if (color < 0 || color > 11) {
            color = 0;
        }

        // if (force || !this.cells[col][row].on || this.cells[col][row].color !== color) {
        if (force || this.cells[col][row].color !== color) {

            midi.send([
                ...CC(20, col, 0),      // TODO: configure channel
                ...CC(21, row, 0),
                ...CC(22, color, 0),
            ]);

            // // cells[col][row].vel = bytes[2];
            // console.log("update cell", col, row);
            // this.cells[col][row].on = true;  // still used?
            this.cells[col][row].color = color;
        }

    }

    turnOffCell(col: number, row: number, force=false) {

        // console.log("turnoff", col, row);

        //FIXME: check parameters range

        if (force || (this.cells[col][row].color !== COLOR_OFF)) {

            midi.send([
                ...CC(20, col, 0),
                ...CC(21, row, 0),
                ...CC(22, COLOR_OFF, 0)
            ]);

            // console.log("update cell", col, row);
            // this.cells[col][row].on = false;  // still used?
            this.cells[col][row].color = COLOR_OFF;

        }
    }

    toggleCell(col: number, row: number, color: number) {
        if (this.cells[col][row].color === COLOR_OFF) {
            this.turnOnCell(col, row, color);
        } else {
            this.turnOffCell(col, row);
        }
    }

    //==================================================================================================================


}

// To simplify the implementation (for now), we setup the cells array to match the biggest LinnStrument, so we don't have to
// redimension it if we change the LinnStrument model.

export const Linn = new LinnStore(DIMENSIONS[LINN200].cols, DIMENSIONS[LINN200].rows);
